import React, { PropTypes, Component, Fragment } from 'react'
import { ModalTrigger } from '../components/Modales.jsx'
import Modal from 'react-bootstrap/lib/Modal.js'
import api from '../../../apiClient/v1'


export default class Pasaje extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fecha: '',
            hora: '',
            data: [],
            origen: '',
            destino: '',
            comunasOrigen: [],
            comunasDestino: [],
            buscarOrigen: '',
            buscarDestino: '',
            archivo: '',
            subiendo: false,
            viendoPasaje: false,
            rutaArchivo: '',
        }

        this.onChangeFecha = (e) => {
            const value = e.target.value
            this.setState({
                fecha: value
            })
        }

        this.onChangeHora = (e) => {
            const value = e.target.value
            this.setState({
                hora: value
            })
        }

        this.onChangeComuna = (e) => {
            const comuna = e.target.value
            const nombre = e.target.name
            if (nombre == 'origen') {
                this.setState({ origen: comuna })
            } else if (nombre == 'destino') {
                this.setState({ destino: comuna })
            }
        }

        this.onChangeBuscarOrigen = (e) => {
            const value = e.target.value
            this.setState({
                buscarOrigen: value
            })
            if (value.length > 2) {
                const filtrados = this.state.data.comunas.filter((dato) =>
                    dato.nombre.toLowerCase().startsWith(value.toLowerCase())
                );
                this.setState({
                    comunasOrigen: filtrados
                });
            } else {
                this.setState({
                    comunasOrigen: []
                });
            }
        }

        this.onChangeBuscarDestino = (e) => {
            const value = e.target.value
            this.setState({
                buscarDestino: value
            })
            if (value.length > 2) {
                const filtrados = this.state.data.comunas.filter((dato) =>
                    dato.nombre.toLowerCase().startsWith(value.toLowerCase())
                );
                this.setState({
                    comunasDestino: filtrados
                });
            } else {
                this.setState({
                    comunasDestino: []
                });
            }
        }

        this.onChangeFile = (e) => {
            this.setState({
                archivo: e.target.files[0]
            });
        }

        this.onClickPasaje = (ruta, id) => {
            this.setState({
                viendoPasaje: id,
                rutaArchivo: ruta
            })
        }

        this.cerrarModalArchivo = () => {
            this.setState({ viendoPasaje: false });
        }

        this.onChangeRuta = (ruta) => {
            this.setState({
                rutaArchivo: ruta
            })
        }

        this.onUploadRuta = (id, archivo) => {
            let formData = new FormData();
            formData.append("id", id);
            formData.append("archivo", archivo);
            api.nomina(this.props.nomina.idNomina)
                .editarPasaje(formData)
                .then((response) => {
                    let newData = Object.assign({}, this.state.data);
                    newData.pasajes = response;
                    this.setState({ data: newData });
                })
                .catch((error) => {
                    console.error("Error al cargar los datos:", error);
                });
        };

        this.onDeleteRuta = (id) => {
            api.nomina(this.props.nomina.idNomina)
                .eliminarPasaje(id)
                .then((response) => {
                    let newData = Object.assign({}, this.state.data);
                    newData.pasajes = response;
                    this.setState({ data: newData });
                })
                .catch((error) => {
                    console.error("Error al cargar los datos:", error);
                });
        };

        this.fetchData = () => {
            api.nomina(this.props.nomina.idNomina).verPasajesLider()
                .then((response) => {
                    this.setState({ data: response, origen: response.origen.cutComuna, destino: response.destino.cutComuna });
                })
                .catch((error) => {
                    console.error('Error al cargar los datos:', error);
                });
        };
        this.onSavePasaje = () => {
            const logistica = this.state.data.logistica.id
            this.setState({ subiendo: true })
            const { fecha, hora, origen, destino, archivo } = this.state;
            let data = new FormData()
            data.append('fecha', fecha);
            data.append('hora', hora);
            data.append('origen', origen);
            data.append('destino', destino);
            data.append('archivo', archivo);
            data.append('logistica', logistica);
            api.nomina(this.props.nomina.idNomina).subirPasajesLider(data)
                .then((response) => {
                    const nuevaData = Object.assign({}, this.state.data, {
                        pasajes: response
                    });

                    this.setState({
                        subiendo: false,
                        data: nuevaData
                    });
                })
                .catch((error) => {
                    console.error('Error al guardar el pasaje:', error);
                });
        }
    }

    render() {
        return (
            <div>
                <ModalTrigger>
                    {(isVisible, showModal, hideModal) => {
                        const handleShowModal = () => {
                            showModal(); // Abre el modal
                            this.fetchData(); // Carga los datos
                        };
                        const handleHideModal = () => {
                            hideModal();
                            this.setState({ comunas: [], viendoPasaje: false, });
                        };
                        return (
                            <div>
                                <button className="btn btn-info"
                                    onClick={handleShowModal}>Pasaje
                                </button>
                                {isVisible && <ModalPasaje
                                    hideModal={handleHideModal}
                                    fecha={this.state.fecha}
                                    changeFecha={this.onChangeFecha.bind(this)}
                                    hora={this.state.hora}
                                    changeHora={this.onChangeHora.bind(this)}
                                    data={this.state.data}
                                    comunasOrigen={this.state.comunasOrigen}
                                    comunasDestino={this.state.comunasDestino}
                                    buscarOrigen={this.state.buscarOrigen}
                                    buscarDestino={this.state.buscarDestino}
                                    onBuscarOrigen={this.onChangeBuscarOrigen.bind(this)}
                                    onBuscarDestino={this.onChangeBuscarDestino.bind(this)}
                                    changeFile={this.onChangeFile.bind(this)}
                                    changeComuna={this.onChangeComuna.bind(this)}
                                    origen={this.state.origen}
                                    destino={this.state.destino}
                                    subir={this.onSavePasaje.bind(this)}
                                    subiendo={this.state.subiendo}
                                    viendoPasaje={this.state.viendoPasaje}
                                    onClickPasaje={this.onClickPasaje.bind(this)}
                                    rutaArchivo={this.state.rutaArchivo}
                                    onChangeRuta={this.onChangeRuta.bind(this)}
                                    onUploadRuta={this.onUploadRuta.bind(this)}
                                    onDeleteRuta={this.onDeleteRuta.bind(this)}
                                    administraPasajes={this.props.administraPasajes}
                                />}
                                {this.state.viendoPasaje && (
                                    <ModalArchivo
                                        hideModal={this.cerrarModalArchivo}
                                        viendoPasaje={this.state.viendoPasaje}
                                        ruta={this.state.rutaArchivo}
                                    />
                                )}
                            </div>
                        )
                    }}
                </ModalTrigger>
            </div>
        )
    }
}

const ModalPasaje = ({ hideModal, fecha, changeFecha, hora, changeHora, data, comunasOrigen, comunasDestino, buscarOrigen, buscarDestino, onBuscarOrigen, onBuscarDestino, changeFile, changeComuna, origen, destino, subir, subiendo, viendoPasaje, onClickPasaje, rutaArchivo, onChangeRuta, onUploadRuta, onDeleteRuta, administraPasajes }) => {
    let datos = data && Object.values(data).length > 0 ? Object.values(data.pasajes).sort((a, b) => a.orden - b.orden) : data
    const handleClick = (ruta, id) => {
        onClickPasaje(ruta, id);
    };
    return (
        <Modal show={true} onHide={hideModal} bsSize="lg" style={{
            width: viendoPasaje ? "60%" : "100%",
            transition: "transform 0.3s ease-in-out, width 0.3s ease-in-out"
        }}>
            <Modal.Header closeButton>
                <Modal.Title>Pasajes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <div>
                        <div style={{ display: 'flex', gap: '5px', width: 'full' }}>
                            <div style={{ display: 'grid', width: '50%', marginBottom: '5px' }}>
                                <label>Comuna Origen</label>
                                <input type='text' placeholder='Buscar comuna origen' value={buscarOrigen} onChange={onBuscarOrigen} style={{ width: '75%', padding: '2px', marginBottom: '1px' }} />
                                <select value={origen} name="origen" onChange={changeComuna} style={{ width: '75%', padding: '2px' }} size={5} >
                                    {data && Object.values(data).length > 0 ?
                                        <optgroup label="Comuna Líder">
                                            <option value={data.origen.cutComuna}>{data.origen.nombre}</option>
                                        </optgroup>
                                        : null}
                                    <optgroup label='Comunas'>
                                        {comunasOrigen.length > 0 ? comunasOrigen.map((comuna, index) => {
                                            return (
                                                <option key={index} value={comuna.cutComuna}>{comuna.nombre}</option>
                                            )
                                        })
                                            : (data && Object.values(data).length > 0 ? data.comunas.map((comuna, index) => {
                                                return (
                                                    <option key={index} value={comuna.cutComuna}>{comuna.nombre}</option>
                                                )
                                            })
                                                : null)}
                                    </optgroup>
                                </select>
                            </div>
                            <div style={{ display: 'grid', width: '50%', marginBottom: '5px' }}>
                                <label>Comuna Destino</label>
                                <input type='text' placeholder='Buscar comuna destino' value={buscarDestino} onChange={onBuscarDestino} style={{ width: '75%', padding: '2px', marginBottom: '1px' }} />
                                <select value={destino} name="destino" onChange={changeComuna} style={{ width: '75%', padding: '2px' }} size={5}>
                                    {data && Object.values(data).length > 0 ?
                                        <optgroup label="Comuna Inventario">
                                            <option value={data.destino.cutComuna}>{data.destino.nombre}</option>
                                        </optgroup>
                                        : null}
                                    <optgroup label='Comunas'>
                                        {comunasDestino.length > 0 ? comunasDestino.map((comuna, index) => {
                                            return (
                                                <option key={index} value={comuna.cutComuna}>{comuna.nombre}</option>
                                            )
                                        })
                                            : (data && Object.values(data).length > 0 ? data.comunas.map((comuna, index) => {
                                                return (
                                                    <option key={index} value={comuna.cutComuna}>{comuna.nombre}</option>
                                                )
                                            })
                                                : null)}
                                    </optgroup>
                                </select>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '5px', width: 'full' }}>
                            <div style={{ display: 'grid', width: '50%', marginBottom: '5px' }}>
                                <label>Fecha Pasaje</label>
                                <input type='date' value={fecha} onChange={changeFecha} style={{ width: '75%', padding: '2px' }} />
                            </div>
                            <div style={{ display: 'grid', width: '50%', marginBottom: '5px' }}>
                                <label>Hora Pasaje</label>
                                <input type='time' value={hora} onChange={changeHora} style={{ width: '75%', padding: '2px' }} />
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '4px', width: 'full' }}>
                            <div style={{ display: 'grid', width: '50%' }}>
                                <label>Archivo Pasaje</label>
                                <input type='file' onChange={changeFile} style={{ width: '75%', padding: '2px' }} />
                            </div>
                            <div style={{ display: 'flex', marginTop: '5px' }}>
                                <button className='btn btn-success' onClick={subir} disabled={subiendo}>Subir</button>
                            </div>
                        </div>
                    </div>
                    <br />
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Origen</th>
                                <th>Destino</th>
                                <th>Fecha</th>
                                <th>Hora</th>
                                <th>Subido por</th>
                            </tr>
                        </thead>
                        <tbody>
                            {datos && Object.values(datos).length > 0 ? Object.values(datos).map((pasaje, index) => {
                                return (
                                    <tr key={index}>
                                        <td style={{ verticalAlign: 'middle' }}>{index + 1}</td>
                                        <td style={{ verticalAlign: 'middle' }}>{pasaje.origen}</td>
                                        <td style={{ verticalAlign: 'middle' }}>{pasaje.destino}</td>
                                        <td style={{ verticalAlign: 'middle' }}>{pasaje.fecha}</td>
                                        <td style={{ verticalAlign: 'middle' }}>{pasaje.hora}</td>
                                        <td style={{ verticalAlign: 'middle' }}>{pasaje.subido_por}</td>
                                        <td style={{ verticalAlign: 'middle', display: 'block' }}>
                                            {!pasaje.pdf ?
                                                <input type="file" onChange={(e) => onUploadRuta(pasaje.id, e.target.files[0])}
                                                    style={{ width: '155px', }} />
                                                : <button className={viendoPasaje == pasaje.id ? 'btn btn-success' : 'btn btn-info'} onClick={() => handleClick(pasaje.pdf, pasaje.id)}>
                                                    <span className='glyphicon glyphicon-eye-open'></span>
                                                </button>}
                                        </td>
                                        {administraPasajes && <td style={{ verticalAlign: 'middle' }}>
                                            <button className={'btn btn-danger'} onClick={() => onDeleteRuta(pasaje.id)}>
                                                <span className='glyphicon glyphicon-trash'></span>
                                            </button>
                                        </td>}
                                    </tr>
                                );
                            }) : null}
                        </tbody>
                        {/* {viendoPasaje && <ModalArchivo hideModal={onClickPasaje} viendoPasaje={viendoPasaje} ruta={rutaArchivo} />} */}
                    </table>
                </div>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    )
}

const ModalArchivo = ({ hideModal, viendoPasaje, ruta }) => {
    console.log(ruta, "ruta en modal archivo")
    return (
        <Modal show={true} onHide={hideModal} style={{
            width: "60%",
            transform: viendoPasaje ? "translateX(75%)" : "translateX(0%)",
            transition: "transform 0.3s ease-in-out, width 0.3s ease-in-out"
        }}>
            <Modal.Header closeButton>
                <Modal.Title>Pasaje</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ height: '70%' }}>
                <div>
                    <div style={{ gap: '5px', width: 'full' }}>
                        <iframe src={ruta} width='100%' height='100%'
                            style={{ border: 'none', display: 'flex' }} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    )
}





// WEBPACK FOOTER //
// ./frontEnd/nominas/nominaIG/pasaje/Pasaje.jsx